export default "__VITE_ASSET__9dce2b77__"